// TODO: back-end still has different types in RecentBets, Bet History and Place bet, when will be unified, remove one of those

export enum BetType {
    SINGLE = 'single',
    SUBSCRIPTION = 'subscription',
    COMBINATION = 'combination',
}

export enum EnumBetType {
    SINGLE = 1,
    SUBSCRIPTION,
    COMBINATION,
}
